var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._g(_vm._b({},'el-input',_vm.$attrs,false),_vm.$listeners),[_vm._t("prefix",null,{"slot":"prefix"}),_vm._t("suffix",null,{"slot":"suffix"}),_vm._t("prepend",null,{"slot":"prepend"}),_vm._t("append",null,{"slot":"append"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }